import { Col } from "@amzn/stencil-react-components/layout";
import { RowAttributesFunction, Table, TableSpacing } from "@amzn/stencil-react-components/table";
import { buildColumnDefinitions } from "common/helpers/table-utils";
import { ColumnSetting } from "common/types/config-model";
import { AIForMeTool } from "lib/models/aiforme-models";
import { CatalogicalService } from "lib/services/catalogical-service";
import React, { FC } from "react";
import { useHistory } from "react-router-dom";

import MyAiToolsLoading from "./components/MyAiToolsLoading";
import NoAiTools from "./components/NoAiTools";
import myToolsTableConfig from "./my-ai-tools.table-config.json";
import { useMyAiToolsTable } from "./useMyAiToolsTable";

const client = new CatalogicalService<AIForMeTool>("aiforme");

export const MyAiToolsTable: FC = () => {
  const history = useHistory();
  const columns: ColumnSetting[] = myToolsTableConfig.columns;
  const currentColumnDefinitions = buildColumnDefinitions(columns, { history });
  const { aiTools, loading } = useMyAiToolsTable(client);

  if (loading) {
    return <MyAiToolsLoading />;
  }

  return (
    <Col gridGap={32} width="100%">
      <Table actionHeader="Detail" columns={currentColumnDefinitions} data={aiTools} spacing={TableSpacing.Default} />
      {aiTools.length === 0 && <NoAiTools />}
    </Col>
  );
};
